import { useContext, useEffect, useMemo, useRef } from 'react';
import { Checkbox, CheckboxProps } from '@givebutter/primitives/checkbox';
import { TableRowContext } from 'components/table/TableContext';

interface TableRowCheckboxProps<T> extends CheckboxProps {}

const TableRowCheckbox = <T,>(props: TableRowCheckboxProps<T>) => {
    const { row } = useContext(TableRowContext);
    const ref = useRef<HTMLButtonElement>(null);
    const isChecked = row.getIsSelected();

    useEffect(() => {
        if (ref.current) {
            const td = ref.current.closest('td');
            td?.classList.add('!pr-0', 'w-6');
        }
    }, []);

    const checkboxLabel = useMemo(() => {
        return `${isChecked ? 'Uncheck' : 'Check'} row`;
    }, [isChecked]);

    return (
        <Checkbox
            ref={ref}
            checked={isChecked}
            onCheckedChange={row.getToggleSelectedHandler()}
            onClick={e => e.stopPropagation()}
            aria-label={checkboxLabel}
            {...props}
        />
    );
};

export { TableRowCheckbox };
export type { TableRowCheckboxProps };
